/**
 * Gets the properly formatted media URL for use with the Vue proxy
 * 
 * @param {string} path - The media path or URL
 * @returns {string} - The formatted media URL
 */
export function getMediaUrl(path) {
  // If path is already a complete URL, return it
  if (path && (path.startsWith('http://') || path.startsWith('https://'))) {
    return path;
  }
  
  // If path is missing or empty, return placeholder
  if (!path) {
    return '/images/placeholder.jpg';
  }
  
  // If path doesn't start with a slash, add it
  const cleanPath = path.startsWith('/') ? path : '/' + path;
  
  // Return path that will go through the Vue proxy
  return `/media${cleanPath}`;
} 